import React from 'react'
import styled from 'styled-components'

import Video from './Video'
import Chat from './Chat'
import Sketch from './Sketch'

export default () => {
	return (
		<Container>
			<Video />
			<Chat />
			<Sketch />
		</Container>
	)
}

const Container = styled.section`
	height: 100%;
	overflow: hidden;
	display: flex;
`
